import { useLayoutEffect, useRef } from 'react';
import type { StudioColumn, StudioPeriod } from 'src/components/star-grid/reportStudio.types';
import { revealStudioPeriods } from 'src/components/star-grid/utils/studioPeriodVisibility';

const EMPTY_PERIODS: readonly string[] = [];
export const useStudioPeriodVisibility = (column: StudioColumn, periods: readonly StudioPeriod[]) => {
  const element = useRef<HTMLDivElement>(null);
  const previous = useRef<readonly string[]>();
  const selected = column.kind === 'scenario' ? column.period_ids : EMPTY_PERIODS;
  const scenario = column.kind === 'scenario' ? column.scenario_id : '';
  useLayoutEffect(() => {
    const existing = new Set(previous.current);
    const added = previous.current ? [...selected].reverse().find((id) => !existing.has(id)) : undefined;
    previous.current = selected;
    if (element.current) revealStudioPeriods(element.current, added);
  }, [selected, scenario, periods]);
  return element;
};
